import type { RouteObject } from "react-router-dom";
import { pathname } from "#src/config/pathname";
import VulnerabilitiesDashboard from "#src/pages/vulnerabilities";

export const vulnerabilityRoute: RouteObject = {
  path: pathname.VULNERABILITIES,
  // This does not have breadcrumb
  element: <VulnerabilitiesDashboard />,
};
